/** Leave management permission strings (mirror backend PermissionCatalog). */
export const LeavePermissions = {
  view: 'leave_view',
  manage: 'manage_leave_requests',
  managePolicies: 'leave_manage_policies',
  access: ['leave_view', 'manage_leave_requests', 'leave_manage_policies'] as const,
} as const
